import { contactChannels } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="scroll-mt-24 bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm text-primary-700 bg-primary-100 px-3 py-1.5 rounded-full">
            <i className="ri-customer-service-2-line"></i>
            反馈帮助
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl text-foreground-950 leading-snug">
            遇到疑问时，可以这样处理
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            本站不提供入口跳转，也不承接账号相关操作。下面的说明帮你在遇到问题时，
            知道该往哪个方向去核实，而不是病急乱投医。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {contactChannels.map((item) => (
            <div
              key={item.title}
              className="rounded-lg bg-background-50 border border-background-200/70 p-6 hover:border-primary-300 transition-colors"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 max-w-4xl rounded-lg bg-secondary-900 p-6 md:p-8">
          <div className="flex flex-col md:flex-row md:items-center gap-6">
            <div className="flex-1">
              <h3 className="font-heading text-xl text-background-50">核实来源，是解决疑问的第一步</h3>
              <p className="mt-3 text-sm leading-relaxed text-background-100/85">
                当你对某条地址或入口存疑时，最稳妥的办法是回到官方公布的渠道重新确认一次。
                在确认之前，不要输入账号、密码或验证码，也不要下载任何安装包。
              </p>
            </div>
            <a
              href="#faq"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              返回常见问题
              <i className="ri-arrow-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}